import { omit } from 'es-toolkit/compat';

import { downloadSecondaryAnalysisPolygonsForStudy } from 'api/customerResults';
import { manualSelectionFilters, paginationAndSortingParams } from 'utils/useCasesParams/constants';
import { CasesParams } from 'utils/useCasesParams/types';

export type PolygonsExportScope = 'selected' | 'filtered' | 'whole';
export type PolygonsExcludedCases = 'with' | 'without';

type PolygonDownloadParams = Omit<Parameters<typeof downloadSecondaryAnalysisPolygonsForStudy>[0], 'signal'>;

// Maps a polygon scope choice to the existing study-level polygon download arguments; shared by every opener.
export const getPolygonDownloadParams = ({
  scope,
  excludedCases,
  labId,
  studyId,
  casesParams,
}: {
  scope: PolygonsExportScope;
  excludedCases: PolygonsExcludedCases;
  labId: string;
  studyId: string;
  casesParams: Partial<CasesParams>;
}): PolygonDownloadParams => {
  const withoutPaginationAndSorting = omit(casesParams, paginationAndSortingParams);
  if (scope === 'selected') return { labId, studyId, queryObject: withoutPaginationAndSorting };
  if (scope === 'filtered') {
    return { labId, studyId, queryObject: omit(withoutPaginationAndSorting, manualSelectionFilters) };
  }
  if (excludedCases === 'without') return { labId, studyId };
  // Existing payload shape, preserved unchanged; the variable avoids an excess-property check on `studyId`.
  const queryObject = { studyId, labId, filters: { studyId } };
  return { labId, studyId, queryObject };
};
